import axios from 'axios';

if (process.env.NODE_ENV !== 'development') {
  axios.defaults.baseURL = process.env.DOMAIN;
}

axios.interceptors.request.use(
  request => {
    return request;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    if (error.response.status === 401) {
      window.localStorage.removeItem('mobileUserInfo');
      window.localStorage.setItem('autoLogin', 'true');
      window.location.href = `//${window.location.hostname}/login/mobile?redirect=${encodeURIComponent(
        window.location.href
      )}`;
      return Promise.resolve('login');
    } else if (error.response.status === 422 && error.response.statusText === 'Unprocessable Entity') {
      const errors = error.response.data.errors;
      for (let errorItem in errors) {
        if (errors.hasOwnProperty(errorItem)) {
          error.message = errors[errorItem][0];
          return Promise.reject(error);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
